import React from "react";

const Loading = (props: any) => {
	return (
    <div className="text-center" style={{padding: "50px 0"}}>
      <div className="lds-heart"><div></div></div>
    </div>
	)
}

export default Loading;